import { pattern } from "./pattern";

export const abnValidator = (value) => {
    const abnRegex = new RegExp(pattern.abn);
    if (abnRegex.test(value)) return { valid: true, error: false };
    else return { valid: false, error: "ABN value should be 11 characters" };
}